export const roundNegativeToZero = (num: number) =>
  num < 0 ? 0 : Math.round(num);
